export default "__VITE_ASSET___MpzEyn5__"